export interface Provenance {
  /** Where this number/panel comes from, e.g. "catalog health-agg" */
  source: string
  /** Optional query/derivation shown verbatim in the tooltip. */
  query?: string
  /** ISO-8601 timestamp of the underlying observation. */
  observedAt: string
  /** Data is stale — render the inline stale chip and say so in the tooltip. */
  stale?: boolean
  /** Freeform note, e.g. "1h32m old" or a spec ref like "FR-CAT-05". */
  note?: string
}

/** Adapts an /admin/v2 envelope's `source` block (api/admin.v2.yaml Source schema) into a Provenance. */
export function sourceToProvenance(source: { kind: string; observed_at: string; stale: boolean }, note?: string): Provenance {
  return { source: source.kind, observedAt: source.observed_at, stale: source.stale, note }
}

export function formatProvenance(p: Provenance): string {
  const parts = [`source: ${p.source}`]
  if (p.query) parts.push(p.query)
  parts.push(`observed_at ${p.observedAt}`)
  parts.push(p.stale ? `stale${p.note ? ` (${p.note})` : ''}` : p.note ? p.note : 'fresh')
  return parts.join(' · ')
}
